<template>
  <div>
    <validation-observer ref="sintomatologiaForm">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.dorToracicaTipica"
              name="dor-toracica-tipica"
              :disabled="disableForm"
            >
              Dor Torácica Típica
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.dispneia"
              name="dispneia-sintoma"
              :disabled="disableForm"
            >
              Dispneia
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.palpitacoes"
              name="palpitacoes"
              :disabled="disableForm"
            >
              Palpitações
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.tonturas"
              name="tonturas"
              :disabled="disableForm"
            >
              Tonturas
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.cefaleia"
              name="cefaleia"
              :disabled="disableForm"
            >
              Cefaleia
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.sincopal"
              name="sincopal"
              :disabled="disableForm"
            >
              Síncopal
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.convulsao"
              name="convulsao"
              :disabled="disableForm"
            >
              Convulsão
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.edemas"
              name="edemas-sintoma"
              :disabled="disableForm"
            >
              Edemas
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.tosseSeca"
              name="tosse-seca"
              :disabled="disableForm"
            >
              Tosse Seca
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.tosseProdutiva"
              name="tosse-produtiva"
              :disabled="disableForm"
            >
              Tosse Produtiva
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.perdaDePeso"
              name="perda-de-peso"
              :disabled="disableForm"
            >
              Perda de Peso
            </b-form-checkbox>
          </b-col>
          <b-col cols="6" md="4" lg="3">
            <b-form-checkbox
              v-model="sintomatologia.queixasUrinarias"
              name="queixas-urinarias"
              :disabled="disableForm"
            >
              Queixas Urinárias
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" lg="8">
            <b-form-checkbox
              v-model="sintomatologia.outros"
              name="outros"
              :disabled="disableForm"
            >
              Outros
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" class="mt-2">
            <b-form-group label="Descrição" label-for="v-outros-sintomatologia">
              <b-form-textarea
                v-model="sintomatologia.outrosDescricao"
                :disabled="disableForm || !sintomatologia.outros"
                rows="3"
                max-rows="6"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <ButtonsFormVue
            label-edit="Editar Sintomátologia"
            label-save="Salvar Sintomátologia"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
export default {
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixinsGlobal],
  components: {
    AppCollapseItem,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      sintomatologia: {
        outros: false,
        outrosDescricao: "",
        dorToracicaTipica: false,
        dispneia: false,
        palpitacoes: false,
        tonturas: false,
        cefaleia: false,
        sincopal: false,
        convulsao: false,
        edemas: false,
        tosseSeca: false,
        tosseProdutiva: false,
        perdaDePeso: false,
        queixasUrinarias: false,
      },
    };
  },
  watch: {
    parecer: {
      handler(newVal) {
        if (newVal && newVal.sintomatologia) {
          this.setSintomatologiaData(newVal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Deseja realmente sair da atualização do Sintomátologia?",
          {
            title: "Confirmação",
            size: "sm",
            okVariant: "primary",
            okTitle: "Sim",
            cancelTitle: "Não",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setSintomatologiaData(this.parecer);
      this.$refs.sintomatologiaForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    setSintomatologiaData(data) {
      if (data && data.sintomatologia) {
        this.sintomatologia = {
          id: data.id,
          ...this.sintomatologia,
          ...data.sintomatologia,
        };
      }
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.sintomatologiaForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch(
                "parecerCardiologicoModule/salvarSimtomatologia",
                this.sintomatologia
              )
              .then((response) => {
                this.sintomatologia = {
                  id: response.data.id,
                  ...response.data.sintomatologia,
                };
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Sintomátologia Editada com sucesso!"
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
